import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useTimeout } from 'usehooks-ts';
import Pill from '@ingka/pill';
import Button from '@ingka/button';
import Tooltip from '@ingka/tooltip';
import SSRIcon from '@ingka/ssr-icon';
import iconCheckmark from '@ingka/ssr-icon/paths/checkmark';
import { useModal } from '@pcmp/react-providers';

import { CTA_CONFIRMATION_TIMEOUT, CTA_SCORES } from '@/lib/constants';
import { ContactSider } from '@/components/siders/contact';

export const CtaPopupScore: FC<{
  className?: string;
  onSelectScore: (score: number) => void;
}> = ({ className, onSelectScore }) => {
  const { t } = useTranslation();

  return (
    <div className={`flex flex-col gap-3 ${className}`}>
      <p className="font-bold text-sm text-center">{t('label.rateThisApp')}</p>
      <ul className="flex flex-row justify-between">
        {CTA_SCORES.map(({ score, icon, label }) => (
          <li key={label}>
            <Tooltip
              interactiveCustomTrigger
              position="top"
              tooltipText={t(label)}
            >
              <Pill
                data-testid={`score-${score}`}
                className="bg-transparent"
                iconOnly
                label={t(label)}
                onClick={() => onSelectScore(score)}
                size="small"
                ssrIcon={icon}
              />
            </Tooltip>
          </li>
        ))}
      </ul>
    </div>
  );
};

export const CtaPopupConfirm: FC<{
  className?: string;
  onDismiss: () => void;
}> = ({ className, onDismiss }) => {
  const { t } = useTranslation();
  const { openModal } = useModal();
  const handleOpenContact = () => {
    openModal({
      component: ContactSider,
      props: {},
    });
    onDismiss();
  };

  // Dismiss this popup after a few seconds
  useTimeout(onDismiss, CTA_CONFIRMATION_TIMEOUT);

  return (
    <div className={`flex flex-col gap-3 items-center ${className}`}>
      <SSRIcon paths={iconCheckmark} />

      <Button
        data-testid="goto-contact"
        text={t('label.tellUsMore')}
        type="secondary"
        size="small"
        onClick={handleOpenContact}
      />
    </div>
  );
};
